import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
// import AddPalletesationTables from "../tables/AddPalletesationTable";
import { useFormik, FormikProvider, FieldArray } from "formik";
// import * as Yup from "yup";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createRoot } from 'react-dom/client';
import PropTypes from 'prop-types';

import { loader_image } from "../_components/Imagepath";
// var ReactDOM = require('react-dom');
var Barcode = require('react-barcode');
// import AWS from 'aws-sdk';
// import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET, auth_id } from "../Global";
import $ from "jquery";
const EditRawMaterial = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [checkstatus, setCheckstatus] = useState([]);
  const [palletezationType, setPalletezationType] = useState([]);
  const [value, setValue] = useState({});
  const [productnameLists, setproductnameLists] = useState([]);
  const [valueContents, setValueContents] = useState([]);
  // const [valueQuality, setValueQuality] = useState([]);
  const [supplierName, setSupplierName] = useState([]);
  // const [productLists, setproductLists] = useState([]);
  // const [incomingStatus, setIncomingStatus] = useState([]);
  // const [paymentStatus, setPaymentStatus] = useState([]);
  const [locationLoading, setLocationLoading] = useState([]);
  // const [rawMaterialID, setRawMaterialID] = useState([]);
  const [backendErrors, setBackendErrors] = useState([]);
  const [blweight, setBlweight] = useState([]);
  const [valuechecklist, setValuechecklist] = useState([]);
  const [farmerLists, setFarmerLists] = useState([]);


  const [groupproductLists, setGroupproductLists] = useState([]);
  const [permission, setPermission] = useState({});

  const [barcodeSuppliers, setBarcodeSuppliers] = useState([]);
  const [barcodeProducts, setBarcodeProducts] = useState([]);
  // const setIsButtonDisabled= (false);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false); // New state for tracking initial load

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  console.log(initialLoadComplete);




  const formik = useFormik({
    initialValues: {
      id: value.id,
      lot_number_for_calculation: value.lot_number_for_calculation,
      lot_number: value.lot_number,
      lot_number_product: value.lot_number_product,
      plate_number: value.plate_number,
      driver_name: value.driver_name,
      farmer: value.farmer,
      shift_date: value.shift_date,
      shift: value.shift,
      product: value.product,
      location: value.location,
      supplier: value.supplier,
      //customer: value.customer,
      // production_facility: value.production_facility,
      gross_weight: value.gross_weight,
      net_weight: value.net_weight,
      number_of_boxes: value.number_of_boxes,
      decay_net_weight: value.decay_net_weight,
      incoming_status: value.incoming_status,
      date_time: value.date_time,
      dominant_caliber: value.dominant_caliber,
      bl_number: value.bl_number,
      // rebate: value.rebate,
      // workers_cost: value.workers_cost,
      // transport_cost: value.transport_cost,
      // payment_status: value.payment_status,
      invoice: value.invoice,
      boxes_in: value.boxes_in,
      boxes_out: value.boxes_out,
      note: value.note,
    comments: value.comments,
      palletesation: valueContents,
      //quality_check: valueQuality,
      // quality_check_calibre_dominant: value.quality_check_calibre_dominant, //varchar
      // quality_check_petit_calibre: value.quality_check_petit_calibre,//varchar
      // quality_check_dechet: value.quality_check_dechet,//varchar
      // quality_check_status: value.quality_check_status,//int
      // quality_check_remarks: value.quality_check_remarks,//text
      quality_check: valuechecklist,
      bl_weight: blweight

    },
    enableReinitialize: true,
    //validationSchema: EditUserSchema,
    onSubmit: (values, { setSubmitting }) => {
      axios
        .post("/raw-materials/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {

          $("#form-submit").text("Update Raw material");
          delete backendErrors['error'];
          // actions.setSubmitting(false);
          setSubmitting(false);
          if (response.data.code === 200) {
            //  setBackendSuccess(response.data.message);
            toast.success(response.data.message);
            //   actions.resetForm();
            setTimeout(() => {
              window.location.href = "/raw-materials";
            }, 1000);
          } else if (response.data.code === 422) {
            setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
            setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });



  // const getCategoryTypeProduct =(product_name)=>{

  //   console.log(product_name);
  //   if(product_name != ""){
  //     axios
  //     .get(`/products/listing-category-type-groupby-specific/${product_name}`, {
  //       headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
  //     })
  //     .then((response) => {
  //       if (response.data.code === 200) {
  //         if (response.data.code === 200) {
  //           let products = response.data.data.products;
  //             let productslisting = products.map((customer, index) => ({
  //             label: customer.title,
  //             value: customer.id,
  //             key: `address-${index}`,
  //           }));
  //           setproductLists(productslisting);
  //         } else {
  //           console.log("API response is not an array");
  //         }

  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  //   }


  // }


  // let barcode_dattime = formik.values.date_time;
  // // let barcode_arr  = barcode_dattime.split("T");
  // // let  barcodetime  = barcode_arr[0] + ' '  + barcode_arr[1];
  // let  barcodetime  = barcode_dattime;

  const handlePrint = (barcode_data) => {


    var form_value = formik.values;
    console.log(form_value);
    axios
      .post("/raw-materials/update", form_value, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        delete backendErrors['error'];
        if (response.data.code === 200) {
          //setBackendSuccess(response.data.message);
          toast.success(response.data.message);
          //formik.values.id = formik.values.id;
          // var supplierId = formik.values.supplier;
          // var product_details =  barcodeProducts.find(user => user.id == barcode_data.product);
          // var supplier_details =  barcodeSuppliers.find(user => user.id == supplierId);
          // var suppler_name = (supplier_details && supplier_details.name)?supplier_details.name:"";
          // console.log(formik.values);
          // let get_contents = '';
          // get_contents +=  '<div id="div-print">';
          //     get_contents += '<table classs="table" style="width:100%" >';
          //     get_contents += '<tr>';
          //     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;">Lot Number#</td>';
          //     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;font-weight: 600;">'+value.lot_number.replace(/-[A-Z]+$/, '')+'</td>';
          //     get_contents += '</tr>';
          //     get_contents += '<tr>';
          //     get_contents += '<tr>';
          //     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;">Date And Time#</td>';
          //     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;font-weight: 600;">'+barcodetime+'</td>';
          //     get_contents += '</tr>';
          //     get_contents += '<tr>';

          //     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;">Supplier</td>';
          //     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;font-weight: 600;">'+suppler_name+'</td>';
          //     get_contents += '</tr>';
          //     get_contents += '<tr>';
          //     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;">Product</td>';
          //     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;font-weight: 600;">'+product_details.productname+'</td>';
          //     get_contents += '</tr>';
          //     get_contents += '<tr>';
          //     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;">Gross Weight:</td>';
          //     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;font-weight: 600;">'+barcode_data.gross_weight+'KG</td>';
          //     get_contents += '</tr>';
          //     get_contents += '<tr>';
          //     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;">Net Weight:</td>';
          //     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;font-weight: 600;">'+barcode_data.net_weight+'KG</td>';
          //     get_contents += '</tr>';
          //     get_contents += '<tr>';
          //     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;">Boxes#</td>';
          //     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;font-weight: 600;">'+barcode_data.number_of_boxes+'</td>';
          //     get_contents += '</tr>';
          //     get_contents += '<tr>';
          //     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;">Barcode#</td>';
          //     get_contents += '<td style= "font-size: 40px; font-family: monospace; text-align: left; padding-top: 8px; padding-bottom: 8px;font-weight: 600;">'+barcode_data.barcode+'</td>';
          //     get_contents += '</tr>';
          //     get_contents += ' </table>   <br/>';

          //     // const tempDiv = document.createElement('div');
          //     // ReactDOM.render(
          //     // <BarcodeComponent barcodeData={barcode_data.barcode} />,
          //     // tempDiv
          //     // );
          //     const tempDiv = document.createElement('div');
          //     document.body.appendChild(tempDiv); // Append the div to the DOM

          //     const root = createRoot(tempDiv);
          //     root.render(<BarcodeComponent barcodeData={barcode_data.barcode} />);

          //     // Get the HTML of the React component and append it to the container
          //     const barcodeHtml = tempDiv.innerHTML;
          //     get_contents +=  barcodeHtml;

          //     get_contents +=  '</div>'; 


          //     const width = 300; // width in millimeters
          //     const height = 300; // height in millimeters

          //     // Convert millimeters to pixels (assuming 1mm = 3.779527559 pixels)
          //     const widthInPixels = width * 3.779527559;
          //     const heightInPixels = height * 3.779527559;

          //     // Calculate the position to center the window on the screen
          //     const left = (window.screen.width - widthInPixels) / 2;
          //     const top = (window.screen.height - heightInPixels) / 2;
          //     const windowFeatures = `width=${widthInPixels},height=${heightInPixels},left=${left},top=${top}`;

          //     //  const printWindow = window.open('', '', 'width=800,height=800');
          //     const printWindow = window.open('', '', windowFeatures);
          //     printWindow.document.open();
          //     printWindow.document.write('<html><head><title>Print</title></head><body style="font-size:25px;">');
          //     printWindow.document.write(get_contents);
          //     printWindow.document.write('</body></html>');
          //     printWindow.document.close();
          //     printWindow.print();
          //     printWindow.close();
          handleDownload(barcode_data);

        }

        else if (response.data.code === 422) {
          setBackendErrors(response.data.error);
        }
        else if (response.data.code === 401) {
          setBackendErrors(response.data.error);
        }
        else {
          setBackendErrors(response.data.error);
        }
      });
  };


  const handleDownload = (barcode_data) => {
    const supplierId = value.supplier;
    const product_details = barcodeProducts.find(user => user.id === barcode_data.product);
    const supplier_details = barcodeSuppliers.find(user => user.id === supplierId);
    const supplier_name = (supplier_details && supplier_details.name) ? supplier_details.name : "";

    let get_contents = '';
    get_contents += '<div id="div-print">';

    get_contents += '<table class="table" style="width:100%">';
    get_contents += '<tr><td style="font-size: 40px; font-family: monospace;">Lot Number#</td><td style="font-size: 40px; font-family: monospace; font-weight: 600;">' + cleanCode(value.lot_number) + '</td></tr>';
    get_contents += '<tr><td style="font-size: 40px; font-family: monospace;">Date And Time#</td><td style="font-size: 40px; font-family: monospace; font-weight: 600;">' + value.date_time + '</td></tr>';
    get_contents += '<tr><td style="font-size: 40px; font-family: monospace;">Service.P</td><td style="font-size: 40px; font-family: monospace; font-weight: 600;">' + supplier_name + '</td></tr>';
    get_contents += '<tr><td style="font-size: 40px; font-family: monospace;">Product</td><td style="font-size: 40px; font-family: monospace; font-weight: 600;">' + product_details.name + '</td></tr>';
    get_contents += '<tr><td style="font-size: 40px; font-family: monospace;">Gross Weight:</td><td style="font-size: 40px; font-family: monospace; font-weight: 600;">' + barcode_data.gross_weight + 'KG</td></tr>';
    get_contents += '<tr><td style="font-size: 40px; font-family: monospace;">Net Weight:</td><td style="font-size: 40px; font-family: monospace; font-weight: 600;">' + barcode_data.net_weight + 'KG</td></tr>';
    get_contents += '<tr><td style="font-size: 40px; font-family: monospace;">Boxes#</td><td style="font-size: 40px; font-family: monospace; font-weight: 600;">' + barcode_data.number_of_boxes + '</td></tr>';
    get_contents += '<tr><td style="font-size: 40px; font-family: monospace;">Barcode#</td><td style="font-size: 40px; font-family: monospace; font-weight: 600;">' + barcode_data.barcode + '</td></tr>';
    get_contents += '</table><br/>';

    // Dynamically create temporary div to render BarcodeComponent
    const tempDiv = document.createElement('div');
    document.body.appendChild(tempDiv);

    const root = createRoot(tempDiv);
    root.render(<BarcodeComponent barcodeData={barcode_data.barcode} />);

    // Delay to allow React to render before reading innerHTML
    setTimeout(() => {
      const barcodeHtml = tempDiv.innerHTML;
      get_contents += barcodeHtml;
      get_contents += '</div>';

      const width = 300;
      const height = 300;
      const widthInPixels = width * 3.779527559;
      const heightInPixels = height * 3.779527559;
      const left = (window.screen.width - widthInPixels) / 2;
      const top = (window.screen.height - heightInPixels) / 2;
      const windowFeatures = `width=${widthInPixels},height=${heightInPixels},left=${left},top=${top}`;

      const printWindow = window.open('', '', windowFeatures);
      printWindow.document.open();
      printWindow.document.write('<html><head><title>Print</title></head><body style="font-size:25px;">');
      printWindow.document.write(get_contents);
      printWindow.document.write('</body></html>');
      printWindow.document.close();

      // Delay print slightly to ensure DOM is ready
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);

      // Clean up temp div
      document.body.removeChild(tempDiv);
    }, 500);
  };

  // const BarcodeComponent = ({ barcodeData }) => {
  //   return (
  //     <div>
  //       <Barcode value={barcodeData} width={7} height={120}  displayValue={false} />
  //     </div>
  //   );
  // };
  const BarcodeComponent = ({ barcodeData }) => {
    return (
      <div>
        <Barcode value={barcodeData}  format="CODE128" width={7} height={120} displayValue={false} />
      </div>
    );
  };

  // **Add PropTypes validation**
  BarcodeComponent.propTypes = {
    barcodeData: PropTypes.string.isRequired, // Assuming barcodeData is a string
  };



  useEffect(() => {
    setPermission(FindModuleById(42));
    console.log(permission);


    axios.post("/products/listing-groupby", {}, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    }).then((response) => {
      if (response.data.code === 200) {
        let farmers = response.data.data.products;
        let productslisting = farmers.map((customer, index) => ({
          label: customer.name,
          value: customer.id,
          symbol: customer.symbol,
          key: `product-${index}`
        }));
        setGroupproductLists(productslisting);
      } else {
        console.log("API response is not an array");
      }
    })
      .catch((error) => {
        console.log(error);
      });

    axios
      .post(
        "/suppliers-trader/listing",
        {},
        {
          headers: {
            Authorization: `Bearer ${Authtoken}`,
            Apitoken: Apitoken,
          },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let suppliers = response.data.data.suppliers;
          setBarcodeSuppliers(suppliers);
          let supplierslist = suppliers.map((cat, index) => ({
            label: cat.name,
            value: cat.id,
            key: `categories-${index}`,
          }));
          setSupplierName(supplierslist);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .get(`/helper/palletezation-add-type`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let products = response.data.data.types;
          let productslisting = products.map((customer, index) => ({
            label: customer.title,
            value: customer.id,
            key: `address-${index}`,
          }));
          setPalletezationType(productslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .get(`/helper/quality-check-status`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let products = response.data.data.check_status;
          let productslisting = products.map((customer, index) => ({
            label: customer.title,
            value: customer.id,
            key: `address-${index}`,
          }));
          setCheckstatus(productslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .post(
        "/products/listing-groupby",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let products = response.data.data.products;
          // setBarcodeProducts(products);
          console.log(products);
          let productslisting = products.map((customer, index) => ({
            label: customer.name,
            value: customer.id,
            key: `prodct-${index}`,
          }));
          setproductnameLists(productslisting);
          console.log(productnameLists);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .post(
        "/products/listing-category-type",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let products = response.data.data.products;
          setBarcodeProducts(products);

        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

    // axios
    // .get(`/helpers/get-new-raw-material-palletisations`, {
    //   headers: {
    //     Authorization: `Bearer ${Authtoken}`,
    //     Apitoken: Apitoken,
    //   },
    // })
    // .then((response) => {
    //   if (response.data.code === 200) {
    //     let barcode = response.data.data.barcode;
    //     console.log(barcode);
    //     setNewbarcode(barcode);
    //   } else {
    //     console.log("API response is not an array");
    //   }
    // })
    // .catch((error) => {
    //   console.log(error);
    // });

    // raw_data_invoice ='';

    axios
      .get(`/raw-materials/edit/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {

          // let raw_data = response.data.data.raw;

          setValue(response.data.data.raw);
          setValueContents(response.data.data.raw.palletesation);
          setValuechecklist(response.data.data.raw.quality_check);
          setBlweight(response.data.data.raw.bl_netweight);

          setInitialLoadComplete(true); // Mark initial data load as complete
          // if(response.data.data.raw.product != ""){
          //   axios
          //   .get(`/products/listing-category-type-groupby-specific/${response.data.data.raw.product}`, {
          //     headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          //   })
          //   .then((response) => {
          //     if (response.data.code === 200) {
          //       if (response.data.code === 200) {
          //         let products = response.data.data.products;
          //           let productslisting = products.map((customer, index) => ({
          //           label: customer.title,
          //           value: customer.id,
          //           key: `address-${index}`,
          //         }));
          //         setproductLists(productslisting);
          //       } else {
          //         console.log("API response is not an array");
          //       }

          //     }
          //   })
          //   .catch((error) => {
          //     console.log(error);
          //   });
          // }

        }
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .get(`/helpers/loading-locations`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let locations = response.data.data.locations;
          let locationslisting = locations.map((ord, index) => ({
            label: ord.title,
            value: ord.id,
            key: `location-${index}`,
          }));
          setLocationLoading(locationslisting);
          // setLocationLoading(locations);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });



    axios
      .post(
        "/farmers/listing",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let farmers = response.data.data.farmers;
          let productslisting = farmers.map((customer, index) => ({
            label: customer.name,
            value: customer.id,
            key: `farmer-${index}`,
          }));
          setFarmerLists(productslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });


    axios
      .post(
        "/suppliers-trader/listing",
        {},
        {
          headers: {
            Authorization: `Bearer ${Authtoken}`,
            Apitoken: Apitoken,
          },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let suppliers = response.data.data.suppliers;
          let supplierslist = suppliers.map((cat, index) => ({
            label: cat.name,
            value: cat.id,
            key: `categories-${index}`,
          }));
          setSupplierName(supplierslist);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);



  // const updateShiftDate = (datetime_value) => {
  //   const Input_name = datetime_value;
  //   var datee_timee = Input_name.split('T');
  //   var timee = datee_timee[1].split(":");

  //   console.log(datee_timee);


  //   if (timee[0] >= 0 && timee[0] < 12) {
  //     const date = new Date(datee_timee[0]);
  //     date.setDate(date.getDate() - 1);      
  //     const year = date.getFullYear();
  //     const month = (date.getMonth() + 1).toString().padStart(2, '0');
  //     const day = date.getDate().toString().padStart(2, '0');
  //     var ladtdate =  `${year}-${month}-${day}`; 
  //     console.log(ladtdate);
  //     formik.values.shift_date =  ladtdate;
  //     //formik.setFieldValue('shift_date', ladtdate);
  //     $("#shift_date").val(ladtdate);
  //     $("#shift_date").attr('value', ladtdate);

  //   }else{
  //    formik.values.shift_date =  datee_timee[0];

  //     console.log(datee_timee);
  //     //formik.setFieldValue('shift_date', datee_timee[0]);
  //     $("#shift_date").val(datee_timee[0]);
  //     $("#shift_date").attr('value', datee_timee[0]);
  //   }
  // };

  // let raw_data_invoice ='';
  //   if(value.invoice){
  //     AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
  //     AWS.config.update({
  //     accessKeyId: AWS_ACCESS_KEY_ID,
  //     secretAccessKey: AWS_SECRET_ACCESS_KEY,
  //     region: AWS_DEFAULT_REGION,
  //     signatureVersion: 'v4',
  //     });
  //     const s3 = new AWS.S3();
  //     var params = {Bucket: AWS_BUCKET, Key: value.invoice};
  //     raw_data_invoice = s3.getSignedUrl('getObject', params);

  //   }

  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };


  //   const handleDownload = async (barcode_arr) => {
  //     //barcode_arr
  //     var barcode = barcode_arr.barcode;//'RM0000017';
  //     $("#item-"+barcode+"").removeClass('loader-hide');
  //     $("#item-"+barcode+"").addClass('loader-show');
  //       axios.post(`/raw-materials/pallet-pdf-initial`,barcode_arr, {
  //         responseType: 'blob',
  //         headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
  //     }).then(response => {


  //         const blobpdf = new Blob([response.data], { type: 'application/pdf' });
  //        const blobUrl = URL.createObjectURL(blobpdf);

  //       // Create a new window for printing
  //       const printWindow = window.open(blobUrl);

  //       // Wait for the PDF to load and then trigger printing
  //       printWindow.onload = () => {
  //         printWindow.print();
  //         printWindow.onafterprint = () => {
  //           // Clean up after printing (optional)
  //           URL.revokeObjectURL(blobUrl);
  //         };
  //       };
  //       $("#item-"+barcode+"").addClass('loader-hide');
  //       $("#item-"+barcode+"").removeClass('loader-show');

  //     })
  //     .catch(error => {
  //         console.error('Error downloading PDF:', error);
  //     });
  // };


  // const deleteBarcodeFromDB = (item_id) => {

  //   const response_data = {};
  //   response_data.status = 'false';
  //   axios.get(`/raw-materials/delete-barcode/${item_id}`, {
  //     headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
  //   }).then((response) => {
  //     if (response.data.code === 200) {
  //       response_data.status = 'ok';
  //       return response_data;
  //     }
  //   }).catch((error) => {
  //     console.log(error)
  //     response_data.status = 'false';

  //   });
  //   return response_data;
  // };
  const deleteBarcodeFromDB = async (item_id) => {

    const isConfirm = window.confirm("Are you sure you want to delete this barcode?");

    if (!isConfirm) {
      return { status: 'cancelled' };
    }

    try {
      const response = await axios.get(`/raw-materials/delete-barcode/${item_id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      });

      if (response.data.code === 200) {
        return { status: 'ok' };
      }

      return { status: 'false' };

    } catch (error) {
      console.log(error);
      return { status: 'false' };
    }
  };


  const checkLotNUmber = (lot_number) => {
    delete backendErrors['lot_number'];
    let raw_material_id = formik.values.id

    let lot_number_for_calculation = formik.values.lot_number_for_calculation

    let check_lotnumber = lot_number + ',' + lot_number_for_calculation + ',' + raw_material_id;
    axios.get(`/raw-materials/edit-check-lot-number/${check_lotnumber}`, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    })
      .then((response) => {

        if (response.data.code === 422) {
          setBackendErrors(response.data.error);
        } else {
          console.log(response.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }


  const generateLotNumber = (farmer) => {
    console.log("autoload3");

    delete backendErrors['lot_number'];
    let raw_material_id = formik.values.id
    let lotnumber = formik.values.date_time + "_" + farmer + '_' + formik.values.lot_number_product + '_' + formik.values.location + '_' + raw_material_id;
    if (formik.values.date_time != "" && farmer != "" && formik.values.lot_number_product != '' && formik.values.location != '') {
      console.log('page load');
      axios.get(`/raw-materials/edit-generate-lot-number/${lotnumber}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
        .then((response) => {
          if (response.data.code === 200) {
            if (response.data.code === 200) {
              formik.setFieldValue('lot_number', response.data.data.lot_number_generated);
              formik.setFieldValue('lot_number_for_calculation', response.data.data.lot_number_generated_for_calculation);
              formik.setFieldValue('shift_date', response.data.data.shift_date);
              formik.setFieldValue('shift', response.data.data.shift);

            } else {
              console.log("API response is not an array");
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
  const generateLotNumberLocation = (location) => {
    console.log("autoload2");

    delete backendErrors['lot_number'];
    let raw_material_id = formik.values.id
    let lotnumber = formik.values.date_time + "_" + formik.values.farmer + '_' + formik.values.lot_number_product + '_' + location + "_" + raw_material_id;
    if (formik.values.date_time != "" && formik.values.farmer != "" && formik.values.lot_number_product != "" && location != '' && raw_material_id != '') {
      console.log('page load');
      axios.get(`/raw-materials/edit-generate-lot-number/${lotnumber}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
        .then((response) => {
          if (response.data.code === 200) {
            if (response.data.code === 200) {
              formik.setFieldValue('lot_number', response.data.data.lot_number_generated);
              formik.setFieldValue('lot_number_for_calculation', response.data.data.lot_number_generated_for_calculation);
              formik.setFieldValue('shift_date', response.data.data.shift_date);
              formik.setFieldValue('shift', response.data.data.shift);

            } else {
              console.log("API response is not an array");
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  // const generateLotNumberProduct = (product) => {
  //   console.log("autoload2");

  //   delete backendErrors['lot_number'];
  //   let raw_material_id = formik.values.id
  //   let lotnumber =formik.values.date_time +"_"+formik.values.farmer+'_'+formik.values.location+'_'+product+'_'+raw_material_id;
  //   if(formik.values.date_time != "" && formik.values.farmer !="" && formik.values.location !='' && product !=''){
  //   console.log('page load');
  //     axios.get(`/raw-materials/edit-generate-lot-number/${lotnumber}`, {
  //       headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
  //     })
  //     .then((response) => {
  //       if (response.data.code === 200) {
  //         if (response.data.code === 200) {
  //           formik.setFieldValue('lot_number', response.data.data.lot_number_generated);
  //           formik.setFieldValue('lot_number_for_calculation', response.data.data.lot_number_generated_for_calculation);
  //          } else {
  //           console.log("API response is not an array");
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  //  }  
  // }
  function cleanCode(str) {
    return str.replace(/(-MB|-BFY|-DF)$/, "");
  }
  const generateLotNumberProduct = (product) => {
    delete backendErrors['lot_number'];
    let raw_material_id = formik.values.id;
    let lotnumber = formik.values.date_time + "_" + formik.values.farmer + "_" + product + "_" + formik.values.location + '_' + raw_material_id;
    if (formik.values.date_time != "" && formik.values.farmer != "" && product != "" && location != "" && raw_material_id != "") {

      axios
        .get(`/raw-materials/edit-generate-lot-number/${lotnumber}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if (response.data.code === 200) {
            if (response.data.code === 200) {
              formik.setFieldValue('lot_number', response.data.data.lot_number_generated);
              formik.setFieldValue('lot_number_for_calculation', response.data.data.lot_number_generated_for_calculation);
              formik.setFieldValue('shift_date', response.data.data.shift_date);
              formik.setFieldValue('shift', response.data.data.shift);

            } else {
              console.log("API response is not an array");
            }

          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  const generateLotNumberDateTime = (date_time_rat) => {
    console.log("autoload1");
    delete backendErrors['lot_number'];
    let raw_material_id = formik.values.id
    let date_time = date_time_rat + ":00";
    let lotnumber = date_time + "_" + formik.values.farmer + '_' + formik.values.lot_number_product + '_' + formik.values.location + '_' + raw_material_id;
    if (formik.values.farmer != "" && formik.values.lot_number_product != "" && formik.values.location != "" && date_time != "") {
      axios
        .get(`/raw-materials/edit-generate-lot-number/${lotnumber}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if (response.data.code === 200) {
            if (response.data.code === 200) {
              formik.setFieldValue('lot_number', response.data.data.lot_number_generated);
              formik.setFieldValue('lot_number_for_calculation', response.data.data.lot_number_generated_for_calculation);
              formik.setFieldValue('shift_date', response.data.data.shift_date);
              formik.setFieldValue('shift', response.data.data.shift);


            } else {
              console.log("API response is not an array");
            }

          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };

  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };
  let decisionlist = [

    { value: 'Accepted', label: "Accepted" },
    { value: 'Not Accepted', label: "Not Accepted" },
  ]

  const deleteQCheckFromDB = (item_id) => {
    const response_data = {};
    response_data.status = 'false';
    axios.get(`/raw-materials/delete-quality-check/${item_id}`, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    }).then((response) => {
      if (response.data.code === 200) {
        response_data.status = 'ok';
        return response_data;
      }
    }).catch((error) => {
      console.log(error);

      response_data.status = 'false';

    });
    return response_data;
  };

  const deleteBLlWeightFromDB = (item_id) => {
    const response_data = {};
    response_data.status = 'false';
    axios.get(`/raw-materials/delete-bl-weight/${item_id}`, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    }).then((response) => {
      if (response.data.code === 200) {
        response_data.status = 'ok';
        return response_data;
      }
    }).catch((error) => {
      console.log(error);

      response_data.status = 'false';

    });
    return response_data;
  };


  console.log(checkstatus);
  const calculatePalletNetWeight = (values, index, overrides = {}) => {
    const grossWeight =
      parseFloat(overrides.gross_weight ?? values.palletesation[index].gross_weight) || 0;

    const numberOfBoxes =
      parseFloat(overrides.number_of_boxes ?? values.palletesation[index].number_of_boxes) || 0;

    const boxesWeight =
      parseFloat(overrides.boxes_weight ?? values.palletesation[index].boxes_weight) || 0;

    const palletWeight =
      parseFloat(overrides.pallet_weight ?? values.palletesation[index].pallet_weight) || 0;

    const netWeight =
      grossWeight - ((numberOfBoxes * boxesWeight) + palletWeight);

    return netWeight.toFixed(1);
  };
  let palletezationType2 = [

    { value: 1, label: "Grade A" },
    { value: 2, label: "Grade B" },
  ];
    
  
  

  const result_pallet = formik.values.palletesation.reduce((acc, item) => {
  const type = item.type;
  const weight = parseFloat(item.net_weight) || 0;
  const gross_weight = parseFloat(item.gross_weight) || 0;
  const number_of_boxes = parseFloat(item.number_of_boxes) || 0; // ✅ define boxes here

  // Initialize if not exists
  if (!acc[type]) acc[type] = { weight: 0, grossweight: 0, boxes: 0 };

  // Sum weight, gross weight, and boxes
  acc[type].weight += weight;
  acc[type].grossweight += gross_weight;
  acc[type].boxes += number_of_boxes; // ✅ use it here

  return acc;
}, {});
const formatted_result_pallet = {
  "Grade_A": {
    weight: result_pallet[1]?.weight || 0,
    grossweight: result_pallet[1]?.grossweight || 0,
    boxes: result_pallet[1]?.boxes || 0,
  },
  "Grade_B": {
    weight: result_pallet[2]?.weight || 0,
    grossweight: result_pallet[2]?.grossweight || 0,
    boxes: result_pallet[2]?.boxes || 0,
  },
  "Total": {
    weight: (result_pallet[1]?.weight || 0) + (result_pallet[2]?.weight || 0),
    grossweight: (result_pallet[1]?.grossweight || 0) + (result_pallet[2]?.grossweight || 0),
    boxes: (result_pallet[1]?.boxes || 0) + (result_pallet[2]?.boxes || 0),
  },
};
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /><ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Raw Material</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/raw-materials">Raw Material</Link>
                    </li>
                    <li className="breadcrumb-item active">Edit</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Raw Material Info</h4>
                    {permission && permission.update === 1 && (
                      <FormikProvider value={formik}>
                        <form onSubmit={formik.handleSubmit}>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Date Time</label>
                                <input
                                  type="datetime-local"
                                  name="date_time"
                                  value={formik.values.date_time}
                                  className={
                                    backendErrors.date_time
                                      ? "form-input form-control input-error datetimepicker"
                                      : "form-input form-control datetimepicker"
                                  }
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                    //updateShiftDate(e.target.value);
                                    generateLotNumberDateTime(e.target.value);
                                  }}
                                  onBlur={formik.handleBlur}
                                />

                                <small>
                                  {backendErrors.date_time && (
                                    <span className="form-error mt-1">
                                      {backendErrors.date_time}
                                    </span>
                                  )}
                                </small>
                              </div>
                              <div className="form-group">
                                <label>Lot Number</label>
                                <input
                                  type="text"
                                  name="lot_number"
                                  value={formik.values.lot_number}
                                  className="form-input form-control"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                    checkLotNUmber(e.target.value);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <input
                                  type="hidden"
                                  name="lot_number_for_calculation"
                                  value={formik.values.lot_number_for_calculation}
                                  className="form-input form-control"
                                // onChange={(e) => {
                                //   formik.handleChange(e);
                                //   customHandleInput(e);
                                // }}
                                // onBlur={formik.handleBlur}
                                />

                                <small>
                                  {backendErrors?.lot_number && (
                                    <span className="form-error mt-1">
                                      {backendErrors.lot_number}
                                    </span>
                                  )}
                                </small>
                              </div>
                              <div className="form-group">
                                <label>Plate Number</label>
                                <input
                                  type="text"
                                  name="plate_number"
                                  value={formik.values.plate_number}
                                  className={
                                    backendErrors.plate_number
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }} onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.plate_number && (
                                    <span className="form-error mt-1">
                                      {backendErrors.plate_number}
                                    </span>
                                  )}
                                </small>
                              </div>


                              <div className="form-group status">
                                <label>Supplier Name</label>
                                {supplierName.length > 0 && (
                                  <Select
                                    className="w-100"
                                    value={supplierName.find(option => option.value == formik.values.supplier) || null} // Ensure correct format
                                    name="supplier"
                                    onChange={(selectedOption) => {
                                      handleSelectChange("supplier", selectedOption);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={supplierName}
                                    placeholder="Select"


                                  />
                                )}

                                <small>
                                  {backendErrors.supplier && (
                                    <span className="form-error mt-1">
                                      {backendErrors.supplier}
                                    </span>
                                  )}
                                </small>
                              </div>
                              {/* <div className="form-group">
                                <label>BL Gross Weight</label>
                                <div className="input-group">
                                  <input type="text"
                                    name="gross_weight"
                                    value={formik.values.gross_weight}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onKeyPress={(event) => {
                                      if (!/^[0-9.]$/.test(event.key) || (event.key === "." && event.target.value.includes("."))) {
                                        event.preventDefault();
                                      }
                                    }}
                                    onBlur={formik.handleBlur}
                                    className="form-control" placeholder="BL Gross Weight" aria-label="BL Gross Weight" aria-describedby="basic-addon2" />
                                  <div className="input-group-append">
                                    <span className="input-group-text" id="basic-addon2">KG</span>
                                  </div>
                                </div>
                                <small>
                                  {backendErrors.gross_weight && (
                                    <span className="form-error mt-1">
                                      {backendErrors.gross_weight}
                                    </span>
                                  )}
                                </small>
                              </div> */}


                           
                            </div>

                            <div className="col-md-6">

                              <div className="form-group status">
                                <label>Select Farm</label>
                                {farmerLists.length > 0 && (
                                  <Select
                                    className="w-100"
                                    value={farmerLists.find(option => option.value == formik.values.farmer) || null} // Ensure correct format
                                    name="farmer"
                                    // onChange={(selectedOption) => {
                                    //   handleSelectChange("farmer", selectedOption);
                                    //   generateLotNumber(selectedOption.value);
                                    //   handleFarmerChange(selectedOption.value);
                                    // }}
                                    onChange={(selectedOption) => {
                                      handleSelectChange("farmer", selectedOption);
                                      generateLotNumber(selectedOption.value);
                                      //generateLotNumber(selectedOption.value);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={farmerLists}
                                    placeholder="Select"


                                  />
                                )}


                                <small>
                                  {backendErrors.farmer && (
                                    <span className="form-error mt-1">
                                      {backendErrors.farmer}
                                    </span>
                                  )}
                                </small>
                              </div>
                              <div className="form-group">
                                <label>Driver Name</label>
                                <input
                                  type="text"
                                  name="driver_name"
                                  value={formik.values.driver_name}
                                  className={
                                    backendErrors.driver_name
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.driver_name && (
                                    <span className="form-error mt-1">
                                      {backendErrors.driver_name}
                                    </span>
                                  )}
                                </small>
                              </div>

                              <div className="form-group status">
                                <label>Location</label>
                                {locationLoading.length > 0 && (
                                  <Select
                                    className="w-100"
                                    value={locationLoading.find(option => option.value == formik.values.location) || null} // Ensure correct format
                                    name="location"
                                    // onChange={(selectedOption) => {
                                    // handleSelectChange("location", selectedOption);
                                    // generateLotNumberLocation(selectedOption.value);
                                    // handleLocationChange(selectedOption.value);
                                    // }}
                                    onChange={(selectedOption) => {
                                      handleSelectChange("location", selectedOption);
                                      generateLotNumberLocation(selectedOption.value);
                                      //generateLotNumber(selectedOption.value);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={locationLoading}
                                    placeholder="Select"


                                  />
                                )}
                                <small>
                                  {backendErrors.location && (
                                    <span className="form-error mt-1">
                                      {backendErrors.location}
                                    </span>
                                  )}
                                </small>
                              </div>

                              {/* <div className="form-group">
                                <label>BL Net Weight</label>
                                <div className="input-group">
                                  <input type="text"
                                    name="net_weight"
                                    value={formik.values.net_weight}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onKeyPress={(event) => {
                                      if (!/^[0-9.]$/.test(event.key) || (event.key === "." && event.target.value.includes("."))) {
                                        event.preventDefault();
                                      }
                                    }}
                                    onBlur={formik.handleBlur}
                                    className="form-control" placeholder="BL Net Weight" aria-label="BL Net Weight" aria-describedby="basic-addon2" />
                                  <div className="input-group-append">
                                    <span className="input-group-text" id="basic-addon2">KG</span>
                                  </div>
                                </div>
                                <small>
                                  {backendErrors.net_weight && (
                                    <span className="form-error mt-1">
                                      {backendErrors.net_weight}
                                    </span>
                                  )}
                                </small>
                              </div> */}
                              <div className="form-group status">
                                <label>Product</label>
                                <Select


                                  className="w-100"
                                  value={groupproductLists.find(option => option.value == formik.values.lot_number_product) || null} // Ensure correct format
                                  name="lot_number_product"
                                  onChange={(selectedOption) => {
                                    handleSelectChange("lot_number_product", selectedOption);
                                    generateLotNumberProduct(selectedOption.value);
                                    //generateLotNumber(selectedOption.value);
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={groupproductLists}
                                  placeholder="Select"


                                />

                                <small>
                                  {backendErrors.lot_number_product && (
                                    <span className="form-error mt-1">
                                      {backendErrors.lot_number_product}
                                    </span>
                                  )}
                                </small>
                              </div>

                            </div>
                          </div>

                           <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Note (Type : Tout-venant , statistiques, A , A grade export ....)</label>
                                <textarea
                                  type="text"
                                  name="note"
                                  value={formik.values.note}
                                  className= "form-input form-control"
                                 
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                ></textarea>

                               

                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Comment</label>
                                <textarea
                                  type="text"
                                  name="comments"
                                  value={formik.values.comments}
                                  className= "form-input form-control"
                                 
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                ></textarea>

                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-12">
                              <h4 className="card-title">
                                <br />
                                Add Palletesation
                              </h4>
                            </div>
                            <div className="col-md-12">
                              <FieldArray
                                name="palletesation"
                                render={(arrayHelpers) => (
                                  <div>
                                    <button
                                      className="btn btn-primary mb-3"
                                      type="button"
                                      id="add-barcode-button"
                                      onClick={async () => {
                                        if ($("#add-barcode-button").prop("disabled")) return;
                                        $("#loader-image-add-palletesation").removeClass('loader-hide');
                                        $("#loader-image-add-palletesation").addClass('loader-show');

                                        //setIsButtonDisabled(true);
                                        $("#add-barcode-button").prop("disabled", true);
                                        $("#add-barcode-button").attr('disabled', 'disabled');

                                        try {
                                          await new Promise(resolve => setTimeout(resolve, 500));

                                          axios.get(`/helper/next-raw-material-pallet`, {
                                            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken, },
                                          }).then((response) => {
                                            if (response.data.code === 200) {

                                              let abc_barcode = response.data.data.barcode;
                                              let rawbarcode = (abc_barcode.barcode != null) ? abc_barcode.barcode : '';


                                              let appendArr_1 = arrayHelpers.form.values.palletesation && arrayHelpers.form.values.palletesation[0];

                                              let type_pallet = (appendArr_1 && appendArr_1.type) ? appendArr_1.type : "";
                                              let product_pallet = (appendArr_1 && appendArr_1.product) ? appendArr_1.product : "";
                                              //let net_weight_pallet = (appendArr_1 && appendArr_1.net_weight) ? appendArr_1.net_weight : "";
                                              //let gross_weight_pallet = (appendArr_1 && appendArr_1.gross_weight) ? appendArr_1.gross_weight : "";
                                              let number_of_boxes_pallet = (appendArr_1 && appendArr_1.number_of_boxes) ? appendArr_1.number_of_boxes : "";


                                              let initialArr = {
                                                barcode: rawbarcode,
                                                type: type_pallet,
                                                product: product_pallet,
                                                net_weight: 0,
                                                gross_weight: 0,
                                                pallet_weight: 0,
                                                boxes_weight: 0,
                                                number_of_boxes: number_of_boxes_pallet,
                                              }
                                              arrayHelpers.push(initialArr);

                                              //setIsButtonDisabled(false);
                                              $("#add-barcode-button").prop("disabled", false).removeAttr('disabled');

                                              $("#add-barcode-button").prop("disabled", false);
                                              $("#add-barcode-button").removeAttr('disabled');
                                              $("#loader-image-add-palletesation").addClass('loader-hide');
                                              $("#loader-image-add-palletesation").removeClass('loader-show');

                                            }
                                          });


                                        } catch (error) {
                                          console.error('Error:', error);
                                        } finally {
                                          console.error('Error: finally');

                                        }

                                      }}
                                    >
                                      +
                                      <img id={`loader-image-add-palletesation`} className="loader-image loader-hide" src={loader_image} />
                                    </button>
                                    {console.log(arrayHelpers)}
                                    <table className="table" style={{ tableLayout: 'fixed', width: '100%', minWidth: '1000px' }}>
                                      <thead>
                                        <tr>
                                          <th style={{ width: '16%', minWidth: "16%", whiteSpace: 'normal', wordWrap: 'break-word' }} >Barcode</th>
                                          <th style={{ width: '15%', minWidth: "15%", whiteSpace: 'normal', wordWrap: 'break-word' }} >Product</th>
                                          <th style={{ width: '14%', minWidth: "14%", whiteSpace: 'normal', wordWrap: 'break-word' }} >Type</th>
                                          <th style={{ width: '9%', minWidth: "9%", whiteSpace: 'normal', wordWrap: 'break-word' }} >Number of Boxes</th>
                                          <th style={{ width: '9%', minWidth: "9%", whiteSpace: 'normal', wordWrap: 'break-word' }} >Gross Weight</th>
                                          <th style={{ width: '9%', minWidth: "9%", whiteSpace: 'normal', wordWrap: 'break-word' }} >Boxes weight</th>
                                          <th style={{ width: '9%', minWidth: "9%", whiteSpace: 'normal', wordWrap: 'break-word' }} >Pallet Weight</th>
                                          <th style={{ width: '9%', minWidth: "9%", whiteSpace: 'normal', wordWrap: 'break-word' }} >Net Weight</th>
                                          <th style={{ width: '10%', minWidth: "10%", whiteSpace: 'normal', wordWrap: 'break-word' }} >ACTION</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {formik.values.palletesation.map(
                                          (friend, index) => (
                                            <tr key={index}>
                                              <td style={{ width: '16%', minWidth: "16%" }} >
                                                <div className="form-group status">
                                                  <input
                                                    type="text"
                                                    className="form-input form-control"
                                                    name={`palletesation[${index}].barcode`}
                                                    value={
                                                      formik.values.palletesation[index]
                                                        .barcode
                                                    }

                                                    disabled
                                                  />
                                                </div>
                                              </td>
                                              <td style={{ width: '15%', minWidth: "15%" }} >
                                                <div className="form-group status">
                                                  {productnameLists.length > 0 && (
                                                    <Select
                                                      name={`palletesation[${index}].product`}
                                                      options={productnameLists}
                                                      value={productnameLists.find(option => option.value == formik.values.palletesation[index].product) || null} // Ensure correct format
                                                      onChange={(selectedOption) => {
                                                        formik.setFieldValue(`palletesation[${index}].product`, selectedOption.value); // ✅ Store only value in Formik
                                                        customHandleInput({
                                                          target: {
                                                            name: `palletesation[${index}].product`,
                                                            value: selectedOption.value, // ✅ Ensure only value is passed
                                                          },
                                                        });
                                                      }}
                                                      onBlur={formik.handleBlur}
                                                      placeholder="Select"
                                                      className="w-100"


                                                    />
                                                  )}

                                                </div>
                                              </td>
                                              <td style={{ width: '14%', minWidth: "14%" }} >
                                                <div className="form-group status">
                                                  {palletezationType.length > 0 && (
                                                    <Select
                                                      name={`palletesation[${index}].type`}
                                                      options={palletezationType}
                                                      value={palletezationType.find(option => option.value == formik.values.palletesation[index].type) || null} // Ensure correct format
                                                      onChange={(selectedOption) => {
                                                        formik.setFieldValue(`palletesation[${index}].type`, selectedOption.value); // ✅ Store only value in Formik
                                                        customHandleInput({
                                                          target: {
                                                            name: `palletesation[${index}].type`,
                                                            value: selectedOption.value, // ✅ Ensure only value is passed
                                                          },
                                                        });
                                                      }}
                                                      onBlur={formik.handleBlur}
                                                      placeholder="Select"
                                                      className="w-100"

                                                    />
                                                  )}
                                                </div>
                                              </td>
                                              <td style={{ width: '9%', minWidth: "9%" }} >
                                                <div className="form-group status">

                                                  <input
                                                    type="text"
                                                    className="form-input form-control"
                                                    name={`palletesation[${index}].number_of_boxes`}
                                                    value={formik.values.palletesation[index].number_of_boxes}
                                                    onKeyPress={(event) => {
                                                      if (!/^[0-9.]$/.test(event.key) || (event.key === "." && event.target.value.includes("."))) {
                                                        event.preventDefault();
                                                      }
                                                    }}
                                                    onChange={(event) => {
                                                      formik.handleChange(event);

                                                      const netWeight = calculatePalletNetWeight(formik.values, index, {
                                                        number_of_boxes: event.target.value,
                                                      });

                                                      formik.setFieldValue(`palletesation[${index}].net_weight`, netWeight);
                                                    }}


                                                    placeholder="Boxes" aria-label="Boxes" aria-describedby="basic-addon2" />

                                                </div>
                                              </td>
                                              <td style={{ width: '9%', minWidth: "9%" }} >
                                                <div className="form-group status">

                                                  <input
                                                    type="text"
                                                    className="form-input form-control"
                                                    name={`palletesation[${index}].gross_weight`}
                                                    value={formik.values.palletesation[index].gross_weight}

                                                    onKeyPress={(event) => {
                                                      if (!/^[0-9.]$/.test(event.key) || (event.key === "." && event.target.value.includes("."))) {
                                                        event.preventDefault();
                                                      }
                                                    }}
                                                    onChange={(event) => {
                                                      formik.handleChange(event);

                                                      const netWeight = calculatePalletNetWeight(formik.values, index, {
                                                        gross_weight: event.target.value,
                                                      });

                                                      formik.setFieldValue(`palletesation[${index}].net_weight`, netWeight);
                                                    }}

                                                    placeholder="Gross Weight" />

                                                </div>
                                              </td>
                                              <td style={{ width: '9%', minWidth: "9%" }} >
                                                <div className="form-group status">

                                                  <input
                                                    type="text"
                                                    className="form-input form-control"
                                                    name={`palletesation[${index}].boxes_weight`}
                                                    value={formik.values.palletesation[index].boxes_weight}

                                                    onKeyPress={(event) => {
                                                      if (!/^[0-9.]$/.test(event.key) || (event.key === "." && event.target.value.includes("."))) {
                                                        event.preventDefault();
                                                      }
                                                    }}
                                                    onChange={(event) => {
                                                      formik.handleChange(event);

                                                      const netWeight = calculatePalletNetWeight(formik.values, index, {
                                                        boxes_weight: event.target.value,
                                                      });

                                                      formik.setFieldValue(`palletesation[${index}].net_weight`, netWeight);
                                                    }}

                                                    placeholder="Boxes Weight" />

                                                </div>
                                              </td>
                                              <td style={{ width: '9%', minWidth: "9%" }} >
                                                <div className="form-group status">
                                                  <input
                                                    type="text"
                                                    className="form-input form-control"
                                                    name={`palletesation[${index}].pallet_weight`}
                                                    value={formik.values.palletesation[index].pallet_weight}

                                                    onKeyPress={(event) => {
                                                      if (!/^[0-9.]$/.test(event.key) || (event.key === "." && event.target.value.includes("."))) {
                                                        event.preventDefault();
                                                      }
                                                    }}
                                                    onChange={(event) => {
                                                      formik.handleChange(event);

                                                      const netWeight = calculatePalletNetWeight(formik.values, index, {
                                                        pallet_weight: event.target.value,
                                                      });

                                                      formik.setFieldValue(`palletesation[${index}].net_weight`, netWeight);
                                                    }}

                                                    placeholder="Pallet Weight" aria-label="Pallet Weight" aria-describedby="basic-addon2" />

                                                </div>
                                              </td>
                                              <td style={{ width: '9%', minWidth: "9%" }} >
                                                <div className="form-group status">
                                                  <input
                                                    type="text"
                                                    className="form-input form-control"
                                                    name={`palletesation[${index}].net_weight`}
                                                    value={formik.values.palletesation[index].net_weight}
                                                    onKeyPress={(event) => {
                                                      if (!/^[0-9.]$/.test(event.key) || (event.key === "." && event.target.value.includes("."))) {
                                                        event.preventDefault();
                                                      }
                                                    }}
                                                    onChange={formik.handleChange}
                                                    placeholder="Net Weight" />

                                                </div>
                                              </td>
                                              <td style={{ width: '10%', minWidth: "10%" }} >
                                                <div className="input-group" style={{ display: 'block' }}>
                                                  <div>
                                                    <button type="button" onClick={() => handlePrint(formik.values.palletesation[index])} className="btn btn-primary me-1"  > <i className="fa fa-print" /> <img id={`item-${formik.values.palletesation[index].barcode}`} className="loader-image loader-hide" src={loader_image} />  </button>
                                                    <button
                                                      className="btn btn-danger"
                                                      type="button"
                                                      onClick={() => {
                                                        let item_record = formik.values.palletesation[index];
                                                        if (item_record.id == undefined) {
                                                          arrayHelpers.remove(index)
                                                        } else {
                                                          deleteBarcodeFromDB(item_record.id);
                                                          arrayHelpers.remove(index)
                                                        }
                                                      }}
                                                    >
                                                      -
                                                    </button>

                                                    {index === formik.values.palletesation.length - 1 && (
                                                      <button
                                                        className="btn btn-primary "
                                                        type="button"
                                                        id="add-barcode-button2"
                                                        onClick={async () => {
                                                          // Add palletization logic
                                                          if ($("#add-barcode-button").prop("disabled")) return;
                                                          $("#loader-image-add-palletesation2").removeClass('loader-hide');
                                                          $("#loader-image-add-palletesation2").addClass('loader-show');

                                                          // setIsButtonDisabled(true);
                                                          $("#add-barcode-button2").prop("disabled", true);
                                                          $("#add-barcode-button2").attr('disabled', 'disabled');

                                                          try {
                                                            await new Promise(resolve => setTimeout(resolve, 500));
                                                            axios.get(`/helper/next-raw-material-pallet`, {
                                                              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
                                                            }).then((response) => {
                                                              if (response.data.code === 200) {
                                                                let abc_barcode = response.data.data.barcode;
                                                                let rawbarcode = abc_barcode.barcode || '';
                                                                let appendArr_1 = arrayHelpers.form.values.palletesation[0];

                                                                let initialArr = {
                                                                  barcode: rawbarcode,
                                                                  type: appendArr_1.type || "",
                                                                  product: appendArr_1.product || "",
                                                                  net_weight: 0,
                                                                  gross_weight: 0,
                                                                  pallet_weight: 0,
                                                                  boxes_weight: 0,
                                                                  number_of_boxes: appendArr_1.number_of_boxes || "",
                                                                };

                                                                arrayHelpers.push(initialArr);

                                                                //setIsButtonDisabled(false);
                                                                $("#add-barcode-button2").prop("disabled", false).removeAttr('disabled');
                                                                $("#loader-image-add-palletesation2").addClass('loader-hide').removeClass('loader-show');
                                                              }
                                                            });
                                                          } catch (error) {
                                                            console.error('Error:', error);
                                                          }
                                                        }}
                                                      >
                                                        +
                                                        <img id={`loader-image-add-palletesation`} className="loader-image loader-hide" src={loader_image} />
                                                      </button>
                                                    )}
                                                  </div>
                                                </div>
                                              </td>
                                            </tr>
                                          )
                                        )}


                                        
                                         
                                       

                                        {formik.values.palletesation.length > 0 && (
                                          <>
                                            <tr style={{ borderTop: 'solid' }}>
                                              
                                                <td colSpan={3} style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                <div>
                                                  <div>Total Number Of Boxes</div>
                                                  <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                    Grade A: {Number(formatted_result_pallet.Grade_A.boxes)}
                                                  </p>
                                                  <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                    Grade B: {Number(formatted_result_pallet.Grade_B.boxes)}
                                                  </p>
                                                  <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                    Total: {Number(formatted_result_pallet.Total.boxes)}
                                                  </p>
                                                </div>
                                              </td>
                                               <td colSpan={3} style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                <div>
                                                  <div>Total Gross Weight</div>
                                                  <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                    Grade A: {Number(formatted_result_pallet.Grade_A.grossweight)}
                                                  </p>
                                                  <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                    Grade B: {Number(formatted_result_pallet.Grade_B.grossweight)}
                                                  </p>
                                                  <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                    Total: {Number(formatted_result_pallet.Total.grossweight)}
                                                  </p>
                                                </div>
                                              </td>
                                             
                                              <td colSpan={3} style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                <div>
                                                  <div>Total Net Weight</div>
                                                  <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                    Grade A: {Number(formatted_result_pallet.Grade_A.weight).toFixed(2)}
                                                  </p>
                                                  <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                    Grade B: {Number(formatted_result_pallet.Grade_B.weight).toFixed(2)}
                                                  </p>
                                                  <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                                    Total: {Number(formatted_result_pallet.Total.weight).toFixed(2)}
                                                  </p>
                                                </div>
                                              </td>


                                            </tr>


                                          </>
                                        )}



                                      </tbody>
                                    </table>
                                  </div>
                                )}
                              />
                            </div>
                          </div>




                          <div className="row">
                            <div className="col-md-6">
                              <h4 className="card-title">
                                <br />
                                BL Weight
                              </h4>
                            </div>
                          </div>
                          <FieldArray
                            name="bl_weight"
                            render={(arrayHelpers_bl_weight) => (
                              <div>
                                <button
                                  className="btn btn-primary mb-3"
                                  type="button"
                                  onClick={async () => {
                                    arrayHelpers_bl_weight.push({
                                      product: "",
                                      type: "",
                                      gross_weight: "",
                                      net_weight: "",

                                    });
                                  }}

                                >
                                  +
                                </button>
                                {1 && (
                                  <table className="table mb-0">
                                    <thead>
                                      <tr>
                                        <th>Product</th>
                                        <th>Type</th>
                                        <th>Gross Weight</th>
                                        <th>Net Weight</th>

                                        <th></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {formik.values.bl_weight.map(
                                        (friend, index_bl) => (
                                          <tr key={index_bl}>



                                            <td>
                                              <div className=" status">
                                                <Select
                                                  name={`bl_weight[${index_bl}].product`}
                                                  options={productnameLists}
                                                  value={productnameLists.find(option => option.value == formik.values.bl_weight[index_bl].product) || null} // Ensure correct format
                                                  onChange={(selectedOption) => {
                                                    formik.setFieldValue(`bl_weight[${index_bl}].product`, selectedOption.value); // ✅ Store only value in Formik
                                                    customHandleInput({
                                                      target: {
                                                        name: `bl_weight[${index_bl}].product`,
                                                        value: selectedOption.value, // ✅ Ensure only value is passed
                                                      },
                                                    });
                                                  }}
                                                  onBlur={formik.handleBlur}
                                                  placeholder="Select"
                                                  className="w-100"
                                                />
                                              </div>
                                            </td>

                                            <td>
                                              <div className=" status">
                                                <Select

                                                  name={`bl_weight[${index_bl}].type`}
                                                  options={palletezationType2}
                                                  value={palletezationType2.find(option => option.value == formik.values.bl_weight[index_bl].type) || null} // Ensure correct format
                                                  onChange={(selectedOption) => {
                                                    formik.setFieldValue(`bl_weight[${index_bl}].type`, selectedOption.value); // ✅ Store only value in Formik
                                                    customHandleInput({
                                                      target: {
                                                        name: `bl_weight[${index_bl}].type`,
                                                        value: selectedOption.value, // ✅ Ensure only value is passed
                                                      },
                                                    });
                                                  }}
                                                  onBlur={formik.handleBlur}
                                                  placeholder="Select"
                                                  className="w-100"
                                                />
                                              </div>
                                            </td>

                                            <td>
                                              <div className=" status">
                                                <input type="text"
                                                  className="form-input form-control"
                                                  name={`bl_weight[${index_bl}].gross_weight`}
                                                  value={formik.values.bl_weight[index_bl].gross_weight}
                                                  onChange={formik.handleChange}
                                                />
                                              </div>
                                            </td>
                                            <td>
                                              <div className=" status">
                                                <input type="text"
                                                  className="form-input form-control"
                                                  name={`bl_weight[${index_bl}].net_weight`}
                                                  value={formik.values.bl_weight[index_bl].net_weight}
                                                  onChange={formik.handleChange}
                                                />
                                              </div>
                                            </td>



                                            <td>
                                              <div className="">
                                                <button
                                                  className="btn btn-danger"
                                                  // style={{ marginTop: 30 }}
                                                  type="button"
                                                  // onClick={() =>
                                                  //   arrayHelpers_bl_weight.remove(index_bl)
                                                  // }
                                                  onClick={() => {
                                                    let item_record = formik.values.bl_weight[index_bl];
                                                    if (item_record.id == undefined) {
                                                      arrayHelpers_bl_weight.remove(index_bl)
                                                    } else {
                                                      deleteBLlWeightFromDB(item_record.id);
                                                      arrayHelpers_bl_weight.remove(index_bl)

                                                    }
                                                  }}
                                                >
                                                  -
                                                </button>
                                              </div>
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                )}
                              </div>
                            )}
                          />

                          <div className="row">
                            <div className="col-md-6">
                              <h4 className="card-title">
                                <br />
                                Quality Check
                              </h4>
                            </div>
                          </div>
                          <FieldArray
                            name="quality_check"
                            render={(arrayHelpers) => (
                              <div>
                                <button
                                  className="btn btn-primary mb-3"
                                  type="button"
                                  onClick={async () => {
                                    const nextSimpleNumber = formik.values.quality_check.length + 1;
                                    arrayHelpers.push({
                                      simple_number: nextSimpleNumber.toString(), // Auto-incrementing value
                                      simple_size: "",
                                      unripe_fruits: "",
                                      ripe_fruits: "",
                                      deformed_fruits: "",
                                      decision: "",
                                      remarks: "",
                                    });
                                  }}

                                >
                                  +
                                </button>
                                {1 && (
                                  <table className="table mb-0">
                                    <thead>
                                      <tr>
                                        <th>Sample Number</th>
                                        <th>Sample Size</th>
                                        <th>Unripe Fruits</th>
                                        <th>Ripe Fruits</th>
                                        <th>Deformed Fruits</th>
                                        <th>Decision</th>
                                        <th>Remarks</th>
                                        <th></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {formik.values.quality_check.map(
                                        (friend, index) => (
                                          <tr key={index}>

                                            <td>
                                              <div className=" status">
                                                <input type="text"
                                                  className="form-input form-control"
                                                  name={`quality_check[${index}].simple_number`}
                                                  value={formik.values.quality_check[index].simple_number}
                                                  onChange={formik.handleChange}
                                                />
                                              </div>
                                            </td>
                                            <td>
                                              <div className=" status">
                                                <input type="text"
                                                  className="form-input form-control"
                                                  name={`quality_check[${index}].simple_size`}
                                                  value={formik.values.quality_check[index].simple_size}
                                                  onChange={formik.handleChange}
                                                />
                                              </div>
                                            </td>
                                            <td>
                                              <div className=" status">
                                                <input type="text"
                                                  className="form-input form-control"
                                                  name={`quality_check[${index}].unripe_fruits`}
                                                  value={formik.values.quality_check[index].unripe_fruits}
                                                  onChange={formik.handleChange}
                                                />
                                              </div>
                                            </td>
                                            <td>
                                              <div className=" status">
                                                <input type="text"
                                                  className="form-input form-control"
                                                  name={`quality_check[${index}].ripe_fruits`}
                                                  value={formik.values.quality_check[index].ripe_fruits}
                                                  onChange={formik.handleChange}
                                                />
                                              </div>
                                            </td>
                                            <td>
                                              <div className=" status">
                                                <input type="text"
                                                  className="form-input form-control"
                                                  name={`quality_check[${index}].deformed_fruits`}
                                                  value={formik.values.quality_check[index].deformed_fruits}
                                                  onChange={formik.handleChange}
                                                />
                                              </div>
                                            </td>
                                            <td>
                                              <div className=" status">

                                                <Select
                                                  name={`quality_check[${index}].decision`}
                                                  options={decisionlist}
                                                  value={decisionlist.find(option => option.value == formik.values.quality_check[index].decision) || null} // Ensure correct format
                                                  onChange={(selectedOption) => {
                                                    formik.setFieldValue(`quality_check[${index}].decision`, selectedOption.value); // ✅ Store only value in Formik
                                                    customHandleInput({
                                                      target: {
                                                        name: `quality_check[${index}].decision`,
                                                        value: selectedOption.value, // ✅ Ensure only value is passed
                                                      },
                                                    });
                                                  }}
                                                  onBlur={formik.handleBlur}
                                                  placeholder="Select"
                                                  className="w-100"
                                                />
                                              </div>
                                            </td>
                                            <td>
                                              <div className=" status">
                                                <input type="text"
                                                  className="form-input form-control"
                                                  name={`quality_check[${index}].remarks`}
                                                  value={formik.values.quality_check[index].remarks}
                                                  onChange={formik.handleChange}
                                                />
                                              </div>
                                            </td>

                                            <td>
                                              <div className="">
                                                <button
                                                  className="btn btn-danger"
                                                  // style={{ marginTop: 30 }}
                                                  type="button"
                                                  // onClick={() =>
                                                  //   arrayHelpers.remove(index)
                                                  // }
                                                  onClick={() => {
                                                    let item_record = formik.values.quality_check[index];
                                                    if (item_record.id == undefined) {
                                                      arrayHelpers.remove(index)
                                                    } else {
                                                      deleteQCheckFromDB(item_record.id);
                                                      arrayHelpers.remove(index)

                                                    }
                                                  }}
                                                >
                                                  -
                                                </button>
                                              </div>
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                )}
                              </div>
                            )}
                          />
                          <div className="text-end mt-4">
                            <button className="btn btn-primary" type="submit" id="form-submit" disabled={formik.isSubmitting}>
                              Update Raw material
                            </button>
                          </div>
                        </form>
                      </FormikProvider>
                    )}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default EditRawMaterial;
